import isEmpty from "lodash/isEmpty";
import useAuth from "src/hooks/useAuth";
import { useCustomProjectFields } from "src/contexts/clients";
import { useFieldSettings } from "src/contexts/customFields";
import { useProject } from "src/contexts/project";

export default function useCaptureFilterFields() {
  const currentProject = useProject();
  const display = useFieldSettings(currentProject);
  const { user } = useAuth();
  const displayProjectFields = useCustomProjectFields();

  if (user.company.settings.project_specific_fields && displayProjectFields) {
    return displayProjectFields;
  } else {
    return isEmpty(user.captureTableSettings) ? display : user.captureTableSettings;
  }
}
